import React from "react"
import { DateField } from "ra-ui-materialui"
import { timeOptions } from "lib/consts"
const EnchancedDateField = ({ options, ...props }) => <DateField options={{ ...timeOptions, ...options }} {...props} />
EnchancedDateField.defaultProps = {
  addLabel: true,
};
export default EnchancedDateField